import { DATE_BADGE_MAP } from '@/constants/initiative'

/**
 * It takes an input date string and returns appropriate badge name by comparing input date with current date.
 * Badges returned - badge-past, badge-today, badge-future
 * @param dateString
 * @returns {string}
 */
export default dateString => {
  if (!dateString) return DATE_BADGE_MAP['future']
  const date = new Date(dateString)
  date.setHours(0, 0, 0, 0)
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  if (date.getTime() === today.getTime()) return DATE_BADGE_MAP['today']
  else if (date > today) return DATE_BADGE_MAP['future']
  else return DATE_BADGE_MAP['past']
}
